<template>
  <div :class="['loading-overlay', 'unselectable', dark ? 'loading-overlay-dark' : null]">
    <v-progress-circular :size="size" :color="$config.colors.primary" indeterminate />
  </div>
</template>
<script>
export default {
  name: 'LoadingOverlay',
  props: {
    size: {
      type: Number,
      default: 50
    },
    dark: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style>
.loading-overlay
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .5);
  cursor: wait;
  z-index: 100;
}

.loading-overlay.loading-overlay-dark
{
  background: rgba(0, 0, 0, .5);
}

.loading-overlay .v-progress-circular
{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/loading-overlay.vue